import { render, staticRenderFns } from "./PatentForm.vue?vue&type=template&id=185d88a1&scoped=true&"
import script from "./PatentForm.vue?vue&type=script&lang=ts&"
export * from "./PatentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185d88a1",
  null
  
)

export default component.exports